import React, { useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import CONFIG from "../config";
import { useBranding } from "../context/BrandingContext";
import { Helmet } from "react-helmet-async";
import SEO from "../components/common/SEO";

const Imprint = () => {
    const { i18n } = useTranslation();
    const { branding } = useBranding();
    const [pageData, setPageData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchPage = async () => {
            try {
                const res = await axios.get(`${CONFIG.API_URL}/api/legal/imprint`);
                setPageData(res.data);
            } catch (err) {
                console.error("Failed to fetch imprint:", err);
            } finally {
                setLoading(false);
            }
        };
        fetchPage();
    }, []);

    const isArabic = i18n.language?.startsWith('ar');
    const title = isArabic ? (pageData?.title_ar || "بيانات الاتصال / إخلاء المسؤولية") : (pageData?.title || "Contact / Imprint");
    const content = isArabic ? (pageData?.content_ar || "Content missing.") : (pageData?.content || "Content missing.");
    const email = pageData?.email_override || branding?.contact?.email || "contact@yourbrand.com";

    if (loading) {
        return (
            <div className="flex justify-center items-center min-h-[60vh]">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-brand-primary"></div>
            </div>
        );
    }

    return (
        <>
            <Helmet>
                <html lang={isArabic ? 'ar' : 'en'} dir={isArabic ? 'rtl' : 'ltr'} />
            </Helmet>
            <SEO />
            <div className="max-w-4xl mx-auto px-6 py-20 animate-fade-in-up">
                <h1 className="text-4xl md:text-5xl font-black mb-12 tracking-tight text-center" style={{ color: 'var(--text-header)' }}>
                    {title}
                </h1>
                <div className="prose prose-lg max-w-none leading-relaxed space-y-6" style={{ color: 'var(--text-main)' }} dir={isArabic ? "rtl" : "ltr"}>
                    <div dangerouslySetInnerHTML={{ __html: content }} />

                    <div className="mt-12 p-8 bg-brand-primary/5 rounded-[30px] border border-brand-primary/10">
                        <p className="font-bold mb-2" style={{ color: 'var(--text-header)' }}>
                            {isArabic ? (pageData?.help_title_ar || "هل لديك أسئلة؟") : (pageData?.help_title || "Have questions?")}
                        </p>
                        <p>
                            {isArabic
                                ? (pageData?.help_desc_ar || `إذا كان لديك أي أسئلة بخصوص بيانات الاتصال الخاصة بنا، يرجى الاتصال بنا على `)
                                : (pageData?.help_desc || `If you have any questions regarding our Contact Details, please contact us at `)}
                            {!pageData?.help_desc && !pageData?.help_desc_ar && (
                                <a href={`mailto:${email}`} className="text-brand-primary font-black hover:underline">{email}</a>
                            )}
                            {(pageData?.help_desc || pageData?.help_desc_ar) && (
                                <span className="block mt-2">
                                    <a href={`mailto:${email}`} className="text-brand-primary font-black hover:underline">{email}</a>
                                </span>
                            )}
                        </p>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Imprint;
